var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 15,
    viewBox: "0 0 53 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57563 11.2219L3.39563 7.48187L10.0956 0.421874H13.6956L7.65563 6.92187L5.85563 8.84187L3.57563 11.2219ZM0.675625 14.4219V0.421874H3.89563V14.4219H0.675625ZM10.2556 14.4219L5.27563 8.32187L7.39563 6.02187L14.0356 14.4219H10.2556ZM19.8803 14.4219V0.421874H25.9403C27.1936 0.421874 28.2736 0.628541 29.1803 1.04187C30.087 1.44187 30.787 2.02187 31.2803 2.78187C31.7736 3.54187 32.0203 4.44854 32.0203 5.50187C32.0203 6.54187 31.7736 7.44187 31.2803 8.20187C30.787 8.94854 30.087 9.52187 29.1803 9.92187C28.2736 10.3219 27.1936 10.5219 25.9403 10.5219H21.6803L23.1203 9.10187V14.4219H19.8803ZM28.7803 14.4219L25.2803 9.34187H28.7403L32.2803 14.4219H28.7803ZM23.1203 9.46187L21.6803 7.94187H25.7603C26.7603 7.94187 27.507 7.72854 28.0003 7.30187C28.4936 6.86187 28.7403 6.26187 28.7403 5.50187C28.7403 4.72854 28.4936 4.12854 28.0003 3.70187C27.507 3.27521 26.7603 3.06187 25.7603 3.06187H21.6803L23.1203 1.52187V9.46187ZM37.1473 14.4219L43.3873 0.421874H46.5873L52.8473 14.4219H49.4473L44.3273 2.06187H45.6073L40.4673 14.4219H37.1473ZM40.2673 11.4219L41.1273 8.96187H48.3273L49.2073 11.4219H40.2673Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.b3d9607c664762284f4ebe0c7c754cc8.svg";
export { ForwardRef as ReactComponent };